import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tag } from '../../../ui'
import useRequest from '../../../hooks/useRequest'
import useMount from '../../../hooks/useMount'
import StackedBarChart from './StackedBarChart'
import { getGraphData, getGreenToolsStats, getGreenToolsStatsExpired } from './config'

import style from './style.m.less'

const StackedBarChartFrame: FC = () => {
    const { t } = useTranslation()

    const TOOL_TYPES = {
        RELEASED: 'Выпущенные',
        PAID: 'Погашенные',
        OVERTIME: 'Истек срок действия',
    }

    const options = [
        {
            label: t('main.released'),
            value: TOOL_TYPES.RELEASED,
            id: '835cdaf1-a0ec-4379-9a5e-b225be191148',
        },
        {
            label: t('main.paid'),
            value: TOOL_TYPES.PAID,
            id: 'z9d9f398-2383-48f6-b2b9-11caad7abb1a',
        },
        {
            label: t('main.overtime'),
            value: TOOL_TYPES.OVERTIME,
            id: 'm1a34b33-03be-4211-bc66-c209c6b52e4f',
        },
    ]

    const [toolType, setToolType] = useState(TOOL_TYPES.RELEASED)
    const [withSplitCerts, setWithSplitCerts] = useState(true)

    const { fetch, result } = useRequest(getGraphData)
    const { fetch: fetchGreenToolsStats, result: greenToolsStatsResult } = useRequest(getGreenToolsStats)
    const { fetch: fetchGreenToolsStatsExpired, result: greenToolsStatsExpiredResult } = useRequest(getGreenToolsStatsExpired)

    useMount(() => {
        fetch({})
    })

    const handleCheckboxChange = (checked: boolean) => {
        setWithSplitCerts(checked)
        if (!checked) {
            fetchGreenToolsStats({})
        }
    }

    const onChange = (value: string) => {
        setToolType(value)
        if (value === TOOL_TYPES.OVERTIME) {
            fetchGreenToolsStatsExpired({})
        }
    }

    return (
        <div className={style.stackedBarChart}>
            <div className={style.headerRow}>
                <div>
                    <span className={style.headerPrimary}>{t('main.generationAttributes')}</span>
                    <span className={style.headerSecondary}>({t('main.scale')})</span>
                </div>
                <div>
                    {options.map((item) => {
                        const { label, value, id } = item
                        return (
                            <Tag
                                color={toolType === value ? 'blue' : undefined}
                                style={{ cursor: 'pointer' }}
                                key={id}
                                onClick={() => onChange(value)}
                            >
                                {label}
                            </Tag>
                        )
                    })}
                </div>
            </div>
            <div className={style.graph}>
                <StackedBarChart
                    graphData={result?.stats}
                    toolType={toolType}
                    withSplitCerts={withSplitCerts}
                    onCheckboxChange={handleCheckboxChange}
                    greenToolsStats={!withSplitCerts ? greenToolsStatsResult : undefined}
                    greenToolsStatsExpired={greenToolsStatsExpiredResult}
                />
            </div>
        </div>
    )
}

export default StackedBarChartFrame
